import { Box, styled, Typography } from '@mui/material';

export const MainTextStyled = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'hasDescrBalanced',
})(({ theme, hasDescrBalanced }) => ({
  fontSize: '12px',
  fontWeight: 400,
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: 'normal',
  letterSpacing: 'normal',
  textWrap: hasDescrBalanced ? 'balance' : 'unset',
  color: theme.palette.colors.variantOnPrimaryBackground,
  whiteSpace: 'pre-line',

  '& span': {
    fontSize: '10px',
  },
}));

export const LinkStyled = styled(Box)(({ theme }) => ({
  textTransform: 'uppercase',
  textDecoration: 'underline',
  cursor: 'pointer',
  color: theme.palette.colors.mainFocused,
}));
